/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCapsuleHorizontal = createReactComponent("outline", "capsule-horizontal", "IconCapsuleHorizontal", [["path", { "d": "M3 6m0 6a6 6 0 0 1 6 -6h6a6 6 0 0 1 6 6v0a6 6 0 0 1 -6 6h-6a6 6 0 0 1 -6 -6z", "key": "svg-0" }]]);

export { IconCapsuleHorizontal as default };
//# sourceMappingURL=IconCapsuleHorizontal.mjs.map
